export const VEHICLE_LIST = 'VEHICLE_LIST'
